import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    if (!sessionId) {
      navigate("/");
      return;
    }

    (async () => {
      try {
        const refCode = sessionStorage.getItem("tain_ref_code");
        await api.post("/auth/session", {
          session_id: sessionId,
          referral_code: refCode || null,
        });
        sessionStorage.removeItem("tain_ref_code");
        await refresh();
        window.history.replaceState(null, "", "/feed");
        navigate("/feed", { replace: true });
      } catch (e) {
        console.error("Auth callback failed", e);
        navigate("/");
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
      <div className="text-white/70 text-sm">Signing you in…</div>
    </div>
  );
}
